import * as React from 'react';
import { useIntl } from 'react-intl';
import { useLocation, useRoute } from 'wouter';
import { useRecoilValue } from 'recoil';
import DynamicTable from '../DynamicTable';
import DetailModal from './DetailModal';
import { TABLE_GDPR_PROFILES, TABLE_GDPR_PROFILES_HISTORY } from '../../Services/TableService';
import { tabsByPermission } from '.';
import TabComponent from '../TabComponent';
import { ITableFilter, setTableFilterAtom } from '../../store/recoil/TableState';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import OnlineHelp from '../OnlineHelp';

const GDPR_PROFILE_HISTORY_URL = '/gdpr-profile/history';

export default function GdprProfileHistory() {
  const tableFilter = useRecoilValue<ITableFilter | null>(setTableFilterAtom);
  const { formatMessage: f } = useIntl();
  const [callTable, setCallTable] = React.useState<boolean>(false);
  const [itemId, setItemId] = React.useState<number | null>(null);
  const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
  const [pathname, navigate] = useLocation();
  const [, params] = useRoute(`${GDPR_PROFILE_HISTORY_URL}/edit/:id`);
  const tabs = React.useState(
    tabsByPermission(
      [TABLE_GDPR_PROFILES, TABLE_GDPR_PROFILES_HISTORY],
      TABLE_GDPR_PROFILES_HISTORY
    )
  )[0];
  const { setDocumentTitle } = useDocumentTitle();

  const handleModalForm = (id: number) => {
    setIsModalOpened(true);
    setCallTable(false);
    setItemId(id);
  };

  React.useEffect(() => {
    if (pathname === GDPR_PROFILE_HISTORY_URL) {
      setIsModalOpened(false);
      setItemId(null);
      const documentTitle = `${f({ id: 'tab.gdpr/profile/history' })} - ${f({
        id: 'menu.gdprProfile',
      })} - ${f({ id: 'menu.gdpr' })}`;
      setDocumentTitle(documentTitle);
    } else if (params) {
      setIsModalOpened(true);
      setItemId(Number(params.id));
      const documentTitle = `${f({ id: 'gdprProfile.modal.changeDetail.title' })} - ${f({
        id: 'tab.gdpr/profile/history',
      })} - ${f({
        id: 'menu.gdprProfile',
      })} - ${f({ id: 'menu.gdpr' })}`;
      setDocumentTitle(documentTitle);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const handleCloseModal = () => {
    setIsModalOpened(false);
    setItemId(null);
    navigate(GDPR_PROFILE_HISTORY_URL);
  };

  return (
    <div>
      <div
        className="col-12"
        style={{
          display: '',
        }}
      >
        <div className="row section page-head">
          <h4>
            {`${f({ id: 'gdprProfile.mainTitle' })} / ${f({ id: 'menu.gdprProfile' })}`}{' '}
            <OnlineHelp topic="gdpr-profile" />
          </h4>
        </div>
        <TabComponent tabs={tabs}>
          <div>
            <DynamicTable
              name={TABLE_GDPR_PROFILES_HISTORY}
              mustClosed={true}
              updateTable={callTable}
              openForm={handleModalForm}
              filter={tableFilter}
              routerParams={params}
            />
          </div>

          {isModalOpened && itemId && (
            <div>
              <DetailModal closeCallback={handleCloseModal} id={itemId} />
            </div>
          )}
        </TabComponent>
      </div>
    </div>
  );
}
